module.exports = __webpack_public_path__ + "static/media/DSC07491.a32a887c.jpg";